import React, { FC } from 'react';
import APP from 'stores/APP';
import classlist from 'utils/classlist';
import Picker from './Picker/Picker';
import Select from './Select';
import { FieldSelectProps } from './type';
import './style.scss';

export * from './type';

const FieldSelect: FC<FieldSelectProps> = ({ className, onSearchInputClick, searchPlaceholder, ...restProps }) => {
    const classNames = classlist('field-select-root', className);

    return APP.isTiger ? (
        <Picker
            className={classNames}
            onSearchInputClick={onSearchInputClick}
            searchPlaceholder={searchPlaceholder}
            {...restProps}
        />
    ) : (
        <Select className={classNames} {...restProps} />
    );
};

export default FieldSelect;
